import type { MiddlewareContext } from '@/types/router';
import { useAuthStore } from '@/stores/auth.store';
import type { SignInResponse } from '@/types/api/auth';

export default function guest({ next }: MiddlewareContext) {
    const authStore = useAuthStore();

    const user = authStore.session as SignInResponse | null;
    if (user?.access_token) {
        return next('/');
    }

    return next();
}
